export const MediaType = {
  Image: "image",
  Audio: "audio",
  Video: "video",
  Pdf: "pdf",
  Zip: "zip",
  Text: "text",
  Other: "other",
} as const;

export type MediaType = (typeof MediaType)[keyof typeof MediaType];

export function urlHasExtension(url: string, ...extensions: string[]): boolean {
  const pattern = new RegExp(`\\.(${extensions.join("|")})($|\\?)`, "i");
  return pattern.test(url);
}

export function isMimeType(
  mimeType: string | null | undefined,
  ...types: string[]
): boolean {
  return mimeType != null && types.includes(mimeType);
}

export function getMediaType(
  url: string,
  mimeType: string | null | undefined,
): MediaType {
  if (mimeType?.startsWith("image/") || isHeicUrl(url)) {
    return MediaType.Image;
  }
  if (mimeType?.startsWith("audio/")) {
    return MediaType.Audio;
  }
  if (mimeType?.startsWith("video/")) {
    return MediaType.Video;
  }
  if (mimeType === "application/pdf") {
    return MediaType.Pdf;
  }
  if (mimeType === "application/zip") {
    return MediaType.Zip;
  }
  if (mimeType === "text/plain") {
    return MediaType.Text;
  }
  return MediaType.Other;
}

export function isMediaType(
  url: string,
  mimeType: string | null | undefined,
  type: MediaType,
): boolean {
  return getMediaType(url, mimeType) === type;
}

export function isHeicMimeType(mimeType: string | null | undefined): boolean {
  return isMimeType(mimeType, "image/heic", "image/heif");
}

export function isHeicUrl(url: string): boolean {
  return urlHasExtension(url, "heic", "heif");
}

export function isHeicImage(
  url: string,
  mimeType: string | null | undefined,
): boolean {
  return isHeicMimeType(mimeType) || isHeicUrl(url);
}
